import { render } from "./CreateEditClientView.vue?vue&type=template&id=db921704&scoped=true&ts=true"
import script from "./CreateEditClientView.vue?vue&type=script&lang=ts"
export * from "./CreateEditClientView.vue?vue&type=script&lang=ts"

import "./CreateEditClientView.vue?vue&type=style&index=0&id=db921704&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db921704"]])

export default __exports__